export enum recruiterNewsTypes {
    FETCH_RECRUITER_NEWS_SUCCESS = "FETCH_RECRUITER_NEWS_SUCCESS",
    FETCH_RECRUITER_NEWS_REQUEST = "FETCH_RECRUITER_NEWS_REQUEST",
    FETCH_RECRUITER_NEWS_FAILURE = "FETCH_RECRUITER_NEWS_FAILURE",
}